import React from 'react';
import { motion } from 'framer-motion';
import { reveal } from '../utils/motion';
import { CaseStudyCard } from '../components/CaseStudyCard';
import { SiteHeader } from '../components/SiteHeader';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { caseStudies, heroMetrics } from '../data/caseStudies';
import { clientLogos } from '../data/clientLogos';
import { linkClass } from '../utils/linkClass';
export function Home() {
  return <div className="relative min-h-screen w-full bg-white font-sans text-ink" data-id="element-140" data-mp="24h0qy1bdf38x">
      <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-0 h-[760px] min-[700px]:h-[900px]" style={{
      backgroundImage: 'radial-gradient(rgba(0, 0, 0, 0.14) 1px, transparent 1.5px)',
      backgroundSize: '32px 32px',
      maskImage: 'linear-gradient(to bottom, #000 55%, transparent 100%)',
      WebkitMaskImage: 'linear-gradient(to bottom, #000 55%, transparent 100%)'
    }} data-id="element-141" data-mp="24j4s4bhvxo5i" />
      <div className="relative mx-auto flex max-w-[1347px] flex-col gap-[30px] px-5 py-10 md:px-10" data-id="element-142" data-mp="30vqay33x0utl">
        <SiteHeader data-id="element-143" data-mp="2vyzyrqv8ejdg" />

        <main className="flex flex-col gap-5 min-[700px]:gap-[30px]" data-id="element-144" data-mp="2vyhs00ay0mra">
          <section className="flex flex-col items-center gap-6 py-2 text-center min-[700px]:py-6 md:py-10" data-id="element-145" data-mp="2qxkfa38pckx6">
            <motion.img src="https://cdn.magicpatterns.com/uploads/oThdsUnkXC7FRqpUL19do3/Meikson-Square.jpg" alt="Portrait of Michael Meikson" className="aspect-square w-[100px] shrink-0 rounded-full object-cover" initial={{
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={reveal} data-id="element-146" data-mp="2mw8kljaz19i4" />
            <div className="flex max-w-[1100px] flex-col items-center gap-5" data-id="element-147" data-mp="23am1jdbyvr2y">
              <motion.div className="flex flex-col gap-3" initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              ...reveal,
              delay: 0.05
            }} data-id="element-148" data-mp="1z6ea38e4jx11">
                <h1 className="bg-[linear-gradient(to_bottom,#4a4a4a,#000000)] bg-clip-text text-headline font-semibold text-transparent min-[700px]:text-[4rem]" data-id="element-149" data-mp="1kjfkzk2qpeph">
                  Design that moves business forward.
                </h1>
                <p className="text-subhead text-muted" data-id="element-150" data-mp="1fle0qvtkv9cf">
                  18 years of experience across B2B SaaS, fintech, and healthcare.
                </p>
              </motion.div>
            </div>
          </section>

          <motion.section aria-label="Clients" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          ...reveal,
          delay: 0.15
        }} data-id="element-151" data-mp="28akz9ut17yxo">
            <ul className="grid grid-cols-3 items-center gap-x-4 gap-y-0 min-[700px]:gap-y-2 md:grid-cols-6" data-id="element-152" data-mp="1yjqaaioeil8j">
              {clientLogos.map(logo => <li key={logo.name} className="flex items-center justify-center" data-id="element-153" data-mp="2m89kj3r0h839">
                  <img src={logo.src} alt={logo.name} className="block aspect-[2/1] w-full max-w-[200px] object-contain" data-id="element-154" data-mp="2r2413ybbl6y4" />
                </li>)}
            </ul>
          </motion.section>

          <ul aria-label="Results" className="grid w-full grid-cols-1 gap-3 sm:grid-cols-3 sm:gap-[30px]" data-id="element-155" data-mp="amh77w7n7t4o">
            {heroMetrics.map((m, i) => <motion.li key={m.label} className="flex flex-col rounded-[30px] bg-positive-bg p-5 [container-type:inline-size]" initial={{
            opacity: 0,
            y: 24
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            ...reveal,
            delay: 0.3 + i * 0.06
          }} data-id="element-156" data-mp="kcafan8ktq46" data-mpi={i}>
                <span className="whitespace-nowrap text-[clamp(22px,21cqw,40px)] font-normal leading-[1.35] tracking-[-0.02em] text-positive max-[699px]:text-[28px]" data-id="element-157" data-mp="5oxrervar8am">
                  {m.value}
                </span>
                <span className="text-xl leading-[27px] tracking-[-0.02em] max-[699px]:text-base max-[699px]:leading-6" data-id="element-158" data-mp="1h4w2t2dy66f0">
                  {m.label}
                </span>
              </motion.li>)}
          </ul>

          <section aria-label="Case studies" className="flex flex-col gap-[30px]" data-id="element-159" data-mp="2ccpx4dn88xwg">
            {caseStudies.map(study => <CaseStudyCard key={study.id} study={study} animate data-id="element-160" data-mp="2hb184rp9deg9" />)}
          </section>

          <section className="flex flex-col gap-[30px] pt-2" data-id="element-161" data-mp="2mc76p65lnvxp">
            <div className="flex flex-col gap-3" data-id="element-162" data-mp="2qd0qpofx8qlb">
              <h2 className="text-headline font-semibold" data-id="element-163" data-mp="2qc7rr9n7f5dq">
                AI has become the core of my design practice.
              </h2>
              <p className="text-subhead text-muted" data-id="element-164" data-mp="302k9yv7jqmgp">
                I prototype in code and can ship working software.
              </p>
            </div>
            <div className="grid grid-cols-1 gap-[30px] md:grid-cols-[minmax(0,1fr)_minmax(0,2fr)]" data-id="element-165" data-mp="3513zf5lcmgdt">
              <div className="flex flex-col gap-10" data-id="element-166" data-mp="3a2b8r9353nml">
              <div className="flex flex-col gap-4 text-base leading-[1.6]" data-id="element-167" data-mp="3e221vjg52fua">
                <p data-id="element-168" data-mp="3dzz2i8t3jacw">
                  My primary design tool is Magic Patterns, where I maintain working prototypes of client projects. 
                </p>
                <a href="https://project-unified-inbox-with-filtering-117.magicpatterns.app/" target="_blank" rel="noopener noreferrer" className={`w-fit text-base ${linkClass}`} data-id="element-169" data-mp="yclixyrp8fd3">
                  View RSI Prototype →
                </a>
              </div>
              <div className="flex flex-col gap-4 text-base leading-[1.6]" data-id="element-170" data-mp="1h3w4s1iki1y4">
                <p data-id="element-171" data-mp="1h5z5pgl9dfhm">
                  I built Percelo, an AEO (Answer Engine Optimization), tool solo in about two weeks with Claude Code. 
                </p>
                <a href="https://www.percelo.com" target="_blank" rel="noopener noreferrer" className={`w-fit text-base ${linkClass}`} data-id="element-172" data-mp="17d1iwy98h4d7">
                  Try Percelo →
                </a>
              </div>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/8x9mJt8jkvyUyDgp9GG3CK/Percelo-hero2.png" alt="Percelo AI visibility report open on a laptop" className="h-[325px] w-full self-start rounded-[30px] object-cover object-[50%_45%]" data-id="element-173" data-mp="3ubvt8jnt2e78" />
            </div>
          </section>

          <TestimonialsSection data-id="element-174" data-mp="3amlaewsrjd4w" />
        </main>

        <div className="pt-10" data-id="element-175" data-mp="3altqij8j33ug">
          <SiteHeader as="footer" data-id="element-176" data-mp="3aopr6fbrg6ml" />
        </div>
      </div>
    </div>;
}